export interface Review {
  id: string;
  authorName: string;
  authorAvatar: string;
  authorRole: string;
  content: string;
  rating: number;
  providerName: string;
  courseName: string;
  date: string;
}

// 本番環境用：データはSupabaseデータベースから取得します
export const mockFeaturedReviews: Review[] = [];
